import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * OwnerSubHeader — small back-nav header used on every /owner/* sub-page.
 * Matches the mobile app's screen header (arrow + section title + optional subtitle).
 */
export default function OwnerSubHeader({ title, subtitle, right, testid = "owner-subheader" }) {
  return (
    <div className="flex items-end justify-between gap-3 flex-wrap" data-testid={testid}>
      <div className="min-w-0">
        <Link
          to="/owner"
          className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.3em] font-black text-muted hover:text-white"
          data-testid={`${testid}-back`}
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Admin Console
        </Link>
        <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight leading-none mt-2">{title}</h1>
        {subtitle && <div className="text-muted text-sm font-mono-tight mt-1">{subtitle}</div>}
      </div>
      {right}
    </div>
  );
}
